// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.tab {
    margin: 0 5px;
    padding: 10px 20px;
    cursor: pointer;
    border: none;
    background-color: #f0f0f0;
    border-radius: 5px;
    transition: background-color 0.3s;
}

.tab.active {
    background-color: #0070E9;
    color: white;
}

.calendar {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #E9E9E9;
    margin:10px;
    width:90%;
    justify-content: center;
}

.calendar-header {
    display: flex;
    width: 100%;
    justify-content: space-around;
    /* background-color: #f0f0f0; */
    padding: 10px;
}

.calendar-header-day {
    width: 14.28%;
    text-align: center;
    font-weight: bold;
}

.calendar-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    /* height:100vh; */
}

.calendar-week {
    display: flex;
    width: 100%;
}

.calendar-day {
    width: 14.28%;
    height: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* border: 1px solid #f0f0f0; */
    position: relative;
    transition: background-color 0.3s;
    border-radius: 100px;
    margin-top: 10px;
    gap: 10px;
    margin-right: 5px;
    margin-bottom: 3%;
    font-family: "Inter";
font-size: 18px;
font-weight: 500;
line-height: 22px;
text-align: center;

}

.weekend {
    background-color: #E9000033;
    color:#E90000;
}

.holiday {
    background-color: #008A2733;
    color:#008A27

}

.holiday-name {
    position: absolute;
    top: 27px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    width: 100%;
    margin-top: 10px;
    white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
}

.optional-holiday {
    background-color: #E9D20033;
    font-family:"Inter";
    
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    text-align: center;
    
    color:#C5B521

        
  
}

.Optinalleavegridhl{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    /* line-height: 16.94px; */
    letter-spacing: 0.02em;
    text-align: left;
    justify-content: left;
    color:#C5B521

   }

.optional-holidayforholidaylist {
    /* background-color: #E9D20033; */
    font-family:"Inter";
    
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    text-align: center;
    
    color:#C5B521

        
  
}


.public-holidayforholidaylist {
    /* background-color: #008A2733; */
    font-family:"Inter";
    
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    text-align: center;
    
    color:#008A27

        
  
}


.subtitle1month{
    font-family: "Inter";
font-size: 16px;
font-weight: 700;
line-height: 19.36px;
letter-spacing: 0.02em;
text-align: center;
color:#00162E

}
.captionmonth{
    font-family: "Inter";
font-size: 10px;
font-weight: 700;
line-height: 12.1px;
letter-spacing: 0.02em;
text-align: center;
color: #8798A9;

}



/* leaveMainBackup.jsx */

.LeavestakengraphHeading{
    font-family: "Inter";
font-size: 17px;
font-weight: 700;
line-height: 21.78px;
letter-spacing: 0.02em;
text-align: left;
color:"#002C5D";
margin-top: 1%;

}

.TotalLeavesYearHeading{
    font-family: "Inter";
    font-size: 17px;
    font-weight: 700;
    line-height: 21.78px;
    letter-spacing: 0.02em;
    text-align: left;
    color:"#002C5D";
    margin-top: 5%;

}

.totalCountinholidaylisthead{
    font-family: "Inter";
font-size: 16px;
font-weight: 600;
line-height: 19.36px;
text-align: left;
color:#002C5D

}
.totalCountinholidaylist{
    font-family: "Inter";
font-size: 16px;
font-weight: 600;
line-height: 19.36px;
text-align: left;
color:#0070E9

}

.custom-tooltip {
    background:#ecf3f9 ;
    border: 1px solid #ccc;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 5px;
   top:0;
   font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    font-size: 14px;

}

.custom-tooltip .label {
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    line-height: 16.94px;
    letter-spacing: 0.02em;
}

.holidayListHolidayName{
    font-family:"Inter";
    
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    text-align: left;
    margin-top: 2%;
    
   

}`, "",{"version":3,"sources":["webpack://./src/views/panel/LeaveManagement/LeaveMain.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,kBAAkB;IAClB,iCAAiC;IACjC,oBAAoB;IACpB,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,kBAAkB;;AAElB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B;;AAEJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;QACf,gBAAgB;QAChB,uBAAuB;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;;IAEnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;IAElB;;;;AAIJ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB;;GAED;;AAEH;IACI,iCAAiC;IACjC,mBAAmB;;IAEnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;IAElB;;;;AAIJ;;;AAGA;IACI,iCAAiC;IACjC,mBAAmB;;IAEnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;IAElB;;;;AAIJ;;;AAGA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,kBAAkB;AAClB;;AAEA;AACA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,mBAAmB;AACnB,sBAAsB;AACtB,kBAAkB;AAClB,cAAc;;AAEd;;;;AAIA,wBAAwB;;AAExB;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB,eAAe;AACf,cAAc;;AAEd;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;;AAElB;;AAEA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,gBAAgB;AAChB;;AAEA;AACA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,gBAAgB;AAChB;;AAEA;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;GACnB,KAAK;GACL,oBAAoB;IACnB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;;AAEnB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;;IAEnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;;;;AAIlB","sourcesContent":[".tabs {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.tab {\r\n    margin: 0 5px;\r\n    padding: 10px 20px;\r\n    cursor: pointer;\r\n    border: none;\r\n    background-color: #f0f0f0;\r\n    border-radius: 5px;\r\n    transition: background-color 0.3s;\r\n}\r\n\r\n.tab.active {\r\n    background-color: #0070E9;\r\n    color: white;\r\n}\r\n\r\n.calendar {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    border: 1px solid #E9E9E9;\r\n    margin:10px;\r\n    width:90%;\r\n    justify-content: center;\r\n}\r\n\r\n.calendar-header {\r\n    display: flex;\r\n    width: 100%;\r\n    justify-content: space-around;\r\n    /* background-color: #f0f0f0; */\r\n    padding: 10px;\r\n}\r\n\r\n.calendar-header-day {\r\n    width: 14.28%;\r\n    text-align: center;\r\n    font-weight: bold;\r\n}\r\n\r\n.calendar-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    /* height:100vh; */\r\n}\r\n\r\n.calendar-week {\r\n    display: flex;\r\n    width: 100%;\r\n}\r\n\r\n.calendar-day {\r\n    width: 14.28%;\r\n    height: 40px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    /* border: 1px solid #f0f0f0; */\r\n    position: relative;\r\n    transition: background-color 0.3s;\r\n    border-radius: 100px;\r\n    margin-top: 10px;\r\n    gap: 10px;\r\n    margin-right: 5px;\r\n    margin-bottom: 3%;\r\n    font-family: \"Inter\";\r\nfont-size: 18px;\r\nfont-weight: 500;\r\nline-height: 22px;\r\ntext-align: center;\r\n\r\n}\r\n\r\n.weekend {\r\n    background-color: #E9000033;\r\n    color:#E90000;\r\n}\r\n\r\n.holiday {\r\n    background-color: #008A2733;\r\n    color:#008A27\r\n\r\n}\r\n\r\n.holiday-name {\r\n    position: absolute;\r\n    top: 27px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    text-align: center;\r\n    width: 100%;\r\n    margin-top: 10px;\r\n    white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n}\r\n\r\n.optional-holiday {\r\n    background-color: #E9D20033;\r\n    font-family:\"Inter\";\r\n    \r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    line-height: 22px;\r\n    text-align: center;\r\n    \r\n    color:#C5B521\r\n\r\n        \r\n  \r\n}\r\n\r\n.Optinalleavegridhl{\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    /* line-height: 16.94px; */\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    justify-content: left;\r\n    color:#C5B521\r\n\r\n   }\r\n\r\n.optional-holidayforholidaylist {\r\n    /* background-color: #E9D20033; */\r\n    font-family:\"Inter\";\r\n    \r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    line-height: 22px;\r\n    text-align: center;\r\n    \r\n    color:#C5B521\r\n\r\n        \r\n  \r\n}\r\n\r\n\r\n.public-holidayforholidaylist {\r\n    /* background-color: #008A2733; */\r\n    font-family:\"Inter\";\r\n    \r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    line-height: 22px;\r\n    text-align: center;\r\n    \r\n    color:#008A27\r\n\r\n        \r\n  \r\n}\r\n\r\n\r\n.subtitle1month{\r\n    font-family: \"Inter\";\r\nfont-size: 16px;\r\nfont-weight: 700;\r\nline-height: 19.36px;\r\nletter-spacing: 0.02em;\r\ntext-align: center;\r\ncolor:#00162E\r\n\r\n}\r\n.captionmonth{\r\n    font-family: \"Inter\";\r\nfont-size: 10px;\r\nfont-weight: 700;\r\nline-height: 12.1px;\r\nletter-spacing: 0.02em;\r\ntext-align: center;\r\ncolor: #8798A9;\r\n\r\n}\r\n\r\n\r\n\r\n/* leaveMainBackup.jsx */\r\n\r\n.LeavestakengraphHeading{\r\n    font-family: \"Inter\";\r\nfont-size: 17px;\r\nfont-weight: 700;\r\nline-height: 21.78px;\r\nletter-spacing: 0.02em;\r\ntext-align: left;\r\ncolor:\"#002C5D\";\r\nmargin-top: 1%;\r\n\r\n}\r\n\r\n.TotalLeavesYearHeading{\r\n    font-family: \"Inter\";\r\n    font-size: 17px;\r\n    font-weight: 700;\r\n    line-height: 21.78px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color:\"#002C5D\";\r\n    margin-top: 5%;\r\n\r\n}\r\n\r\n.totalCountinholidaylisthead{\r\n    font-family: \"Inter\";\r\nfont-size: 16px;\r\nfont-weight: 600;\r\nline-height: 19.36px;\r\ntext-align: left;\r\ncolor:#002C5D\r\n\r\n}\r\n.totalCountinholidaylist{\r\n    font-family: \"Inter\";\r\nfont-size: 16px;\r\nfont-weight: 600;\r\nline-height: 19.36px;\r\ntext-align: left;\r\ncolor:#0070E9\r\n\r\n}\r\n\r\n.custom-tooltip {\r\n    background:#ecf3f9 ;\r\n    border: 1px solid #ccc;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n    border-radius: 5px;\r\n   top:0;\r\n   font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    font-size: 14px;\r\n\r\n}\r\n\r\n.custom-tooltip .label {\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n}\r\n\r\n.holidayListHolidayName{\r\n    font-family:\"Inter\";\r\n    \r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    line-height: 22px;\r\n    text-align: left;\r\n    margin-top: 2%;\r\n    \r\n   \r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
